"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRestrictionsLevel = exports.getProjectLinks = exports.getPopulatedCurrentQuerySettings = exports.getFlowBreadcrumbs = exports.getFilteredCurrentProjectForDesign = exports.getFilteredCurrentProjectForDeploy = exports.getDeploymentById = exports.getDeploymentBreadcrumbs = exports.getCurrentSurveyHandles = exports.getCurrentSurvey = exports.getCurrentQueryAssignmentSurveys = exports.getCurrentQueryAssignmentId = exports.getCurrentQueryAssignmentDeployments = exports.getCurrentQueryAssignmentActiveSurveys = exports.getCurrentQueryAssignmentActiveDeployments = exports.getCurrentProjectVisibleDeploymentIds = exports.getCurrentProjectQueries = exports.getCurrentProjectFields = exports.getCurrentProjectExportData = exports.getCurrentProjectDeployments = exports.getCurrentProjectAssignments = exports.getCurrentProjectActiveAssignments = exports.getCurrentProject = exports.getCurrentDeployments = exports.getCurrentDeploymentSurveys = exports.getCurrentDeploymentIds = exports.getCurrentDeployment = exports.getCurrentAssignmentSurveys = exports.getCurrentAssignmentId = exports.getCurrentAssignmentDeployments = exports.getCurrentAssignment = exports.getAvailableTags = void 0;
var _reselect = require("reselect");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Fortress = window.cccisd.fortress;
var getOrganizationList = function getOrganizationList(state) {
  return state.organizationList;
};
var getProjectList = function getProjectList(state) {
  return state.projectList;
};
var getCurrentProjectId = function getCurrentProjectId(state) {
  return state.currentProjectId;
};
var getCurrentAssignmentId = function getCurrentAssignmentId(state) {
  return state.currentAssignmentId;
};
exports.getCurrentAssignmentId = getCurrentAssignmentId;
var getCurrentQueryAssignmentId = function getCurrentQueryAssignmentId(state) {
  return state.currentQuerySettings.assignmentId;
};
exports.getCurrentQueryAssignmentId = getCurrentQueryAssignmentId;
var getCurrentQuerySettings = function getCurrentQuerySettings(state) {
  return state.currentQuerySettings;
};
var getCurrentDeploymentId = function getCurrentDeploymentId(state) {
  return state.currentDeploymentId;
};
var getCurrentDeploymentIds = function getCurrentDeploymentIds(state) {
  return state.currentDeploymentIds;
};
exports.getCurrentDeploymentIds = getCurrentDeploymentIds;
var getCurrentSurveyId = function getCurrentSurveyId(state) {
  return state.currentSurveyId;
};
var getCurrentSurveyHandles = function getCurrentSurveyHandles(state) {
  return state.currentSurveyHandles;
};
exports.getCurrentSurveyHandles = getCurrentSurveyHandles;
var getCurrentSurveyListHandles = function getCurrentSurveyListHandles(state) {
  return state.currentSurveyListHandles;
};
var getFlowId = function getFlowId(state, props) {
  return Number(props.match.params.flowId);
};
var getDesignFilter = function getDesignFilter(state) {
  return state.designFilter;
};
var getDeployFilter = function getDeployFilter(state) {
  return state.deployFilter;
};
var getQueryList = function getQueryList(state) {
  return state.queryList;
};
var getVisibleDeploymentIds = function getVisibleDeploymentIds(state) {
  return state.visibleDeploymentIds;
};
var getCurrentProject = (0, _reselect.createSelector)(getProjectList, getCurrentProjectId, getCurrentSurveyListHandles, function (projectList, currentProjectId) {
  var currentSurveyListHandles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var result = projectList.find(function (project) {
    return project.groupId === currentProjectId;
  });
  if (!result) {
    return null;
  }
  if (!result.flows) {
    return result;
  }
  result.flows.assignmentList = result.flows.assignmentList.map(function (assignment) {
    if (!assignment.surveylistList) {
      return assignment;
    }
    var currentSurveylistList = currentSurveyListHandles[assignment.assignmentId] ? assignment.surveylistList.find(function (item) {
      return item.surveylistHandle === currentSurveyListHandles[assignment.assignmentId];
    }) : assignment.surveylistList[0];
    return _objectSpread(_objectSpread({}, assignment), {}, {
      currentSurveylistList: currentSurveylistList
    });
  });

  // we need shallow copy here just to update connected components
  return _objectSpread({}, result);
});
exports.getCurrentProject = getCurrentProject;
var getFilteredCurrentProjectForDesign = (0, _reselect.createSelector)(getCurrentProject, getDesignFilter, function (currentProject, designFilter) {
  if (!designFilter) {
    return currentProject;
  }
  designFilter = designFilter.toUpperCase();
  return _objectSpread(_objectSpread({}, currentProject), {}, {
    flows: {
      assignmentList: currentProject.flows.assignmentList.filter(function (assignment) {
        if (assignment.archived) {
          return false;
        }
        return (assignment.label || '').toUpperCase().includes(designFilter) || (assignment.description || '').toUpperCase().includes(designFilter) || assignment.currentSurveylistList.surveyList.filter(function (survey) {
          return !survey.archived;
        }).some(function (survey) {
          return (survey.label || '').toUpperCase().includes(designFilter) || (survey.description || '').toUpperCase().includes(designFilter);
        });
      })
    }
  });
});
exports.getFilteredCurrentProjectForDesign = getFilteredCurrentProjectForDesign;
var getFilteredCurrentProjectForDeploy = (0, _reselect.createSelector)(getCurrentProject, getDeployFilter, function (currentProject, deployFilter) {
  if (!deployFilter) {
    return currentProject;
  }
  deployFilter = deployFilter.toUpperCase();
  return _objectSpread(_objectSpread({}, currentProject), {}, {
    flows: {
      assignmentList: currentProject.flows.assignmentList.filter(function (assignment) {
        if (assignment.archived) {
          return false;
        }
        return (assignment.label || '').toUpperCase().includes(deployFilter) || (assignment.description || '').toUpperCase().includes(deployFilter) || assignment.deploymentList.some(function (survey) {
          return (survey.label || '').toUpperCase().includes(deployFilter);
        });
      })
    }
  });
});
exports.getFilteredCurrentProjectForDeploy = getFilteredCurrentProjectForDeploy;
var getCurrentProjectAssignments = (0, _reselect.createSelector)(getCurrentProject, function (currentProject) {
  if (!currentProject || !currentProject.flows) {
    return [];
  }
  return currentProject.flows.assignmentList;
});
exports.getCurrentProjectAssignments = getCurrentProjectAssignments;
var getCurrentProjectActiveAssignments = (0, _reselect.createSelector)(getCurrentProjectAssignments, function (assignments) {
  return assignments.filter(function (item) {
    return !item.archived;
  });
});
exports.getCurrentProjectActiveAssignments = getCurrentProjectActiveAssignments;
var getCurrentProjectDeployments = (0, _reselect.createSelector)(getCurrentProjectAssignments, function (assignments) {
  var result = [];
  assignments.forEach(function (item) {
    result.push.apply(result, _toConsumableArray(item.deploymentList));
  });
  return result;
});
exports.getCurrentProjectDeployments = getCurrentProjectDeployments;
var getCurrentProjectVisibleDeploymentIds = (0, _reselect.createSelector)(getCurrentProjectDeployments, getVisibleDeploymentIds, function (deployments, visibleDeploymentIds) {
  var deploymentIds = deployments.map(function (obj) {
    return obj.deploymentId;
  });
  if (visibleDeploymentIds) {
    var set = new Set(visibleDeploymentIds);
    return deploymentIds.filter(function (id) {
      return set.has(id);
    });
  }
  return deploymentIds;
});
exports.getCurrentProjectVisibleDeploymentIds = getCurrentProjectVisibleDeploymentIds;
var getCurrentAssignmentDeployments = (0, _reselect.createSelector)(getCurrentProjectAssignments, getCurrentAssignmentId, function (projectAssignments, assignmentId) {
  var result = [];
  projectAssignments.forEach(function (item) {
    result = [].concat(_toConsumableArray(result), _toConsumableArray(item.assignmentId === assignmentId ? item.deploymentList : []));
  });
  return result;
});
exports.getCurrentAssignmentDeployments = getCurrentAssignmentDeployments;
var getCurrentQueryAssignmentDeployments = (0, _reselect.createSelector)(getCurrentProjectAssignments, getCurrentQueryAssignmentId, function (projectAssignments, assignmentId) {
  var result = [];
  projectAssignments.forEach(function (item) {
    result = [].concat(_toConsumableArray(result), _toConsumableArray(item.assignmentId === assignmentId ? item.deploymentList : []));
  });
  return result;
});
exports.getCurrentQueryAssignmentDeployments = getCurrentQueryAssignmentDeployments;
var getCurrentQueryAssignmentActiveDeployments = (0, _reselect.createSelector)(getCurrentQueryAssignmentDeployments, getVisibleDeploymentIds, function (deployments, visibleDeploymentIds) {
  if (!visibleDeploymentIds) {
    return deployments.filter(function (item) {
      return !item.archived;
    });
  }
  var set = new Set(visibleDeploymentIds);
  return deployments.filter(function (item) {
    return !item.archived && set.has(item.deploymentId);
  });
});
exports.getCurrentQueryAssignmentActiveDeployments = getCurrentQueryAssignmentActiveDeployments;
var getCurrentAssignmentSurveys = (0, _reselect.createSelector)(getCurrentProjectAssignments, getCurrentAssignmentId, function (assignments, assignmentId) {
  var assignment = assignments.find(function (item) {
    return item.assignmentId === assignmentId;
  });
  var result = [];
  assignment && assignment.surveylistList.forEach(function (item) {
    result = [].concat(_toConsumableArray(result), _toConsumableArray(item.surveyList));
  });
  return result;
});
exports.getCurrentAssignmentSurveys = getCurrentAssignmentSurveys;
var getCurrentQueryAssignmentSurveys = (0, _reselect.createSelector)(getCurrentProjectAssignments, getCurrentQueryAssignmentId, function (assignments, assignmentId) {
  var assignment = assignments.find(function (item) {
    return item.assignmentId === assignmentId;
  });
  var result = [];
  assignment && assignment.surveylistList.forEach(function (item) {
    result = [].concat(_toConsumableArray(result), _toConsumableArray(item.surveyList));
  });
  return result;
});
exports.getCurrentQueryAssignmentSurveys = getCurrentQueryAssignmentSurveys;
var getCurrentQueryAssignmentActiveSurveys = (0, _reselect.createSelector)(getCurrentQueryAssignmentSurveys, function (surveys) {
  return surveys.filter(function (item) {
    return !item.archived;
  });
});
exports.getCurrentQueryAssignmentActiveSurveys = getCurrentQueryAssignmentActiveSurveys;
var getPopulatedCurrentQuerySettings = (0, _reselect.createSelector)(getCurrentQuerySettings, getCurrentQueryAssignmentActiveDeployments, getCurrentQueryAssignmentActiveSurveys, getVisibleDeploymentIds, function (currentQuerySettings, deployments, surveys, visibleDeploymentIds) {
  var result = _objectSpread({}, currentQuerySettings);
  if (currentQuerySettings.deploymentIds === 'all') {
    result.deploymentIds = deployments.map(function (item) {
      return item.deploymentId;
    });
  }
  if (currentQuerySettings.surveyHandles === 'all') {
    result.surveyHandles = surveys.map(function (item) {
      return item.surveyHandle;
    });
  }
  if (visibleDeploymentIds) {
    result.deploymentIds = (0, _intersection2["default"])(result.deploymentIds, visibleDeploymentIds);
  }
  result.deployments = deployments.filter(function (item) {
    return result.deploymentIds.includes(item.deploymentId);
  });
  return result;
});
exports.getPopulatedCurrentQuerySettings = getPopulatedCurrentQuerySettings;
var getDeploymentById = (0, _reselect.createSelector)(getCurrentProjectDeployments, getCurrentDeploymentId, function (deployments, deploymentId) {
  return deployments.find(function (item) {
    return item.deploymentId === deploymentId;
  });
});
exports.getDeploymentById = getDeploymentById;
var getFlowBreadcrumbs = (0, _reselect.createSelector)(getCurrentProject, getFlowId, function (currentProject, flowId) {
  try {
    var _iterator = _createForOfIteratorHelper(currentProject.flows.assignmentList),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var assignment = _step.value;
        var _iterator2 = _createForOfIteratorHelper(assignment.currentSurveylistList.surveyList),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var survey = _step2.value;
            var _iterator3 = _createForOfIteratorHelper(survey.flowList),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var flow = _step3.value;
                if (flow.flowId === flowId) {
                  return [currentProject.label, assignment.label, survey.label];
                }
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } catch (error) {
    return [];
  }
  return [];
});
exports.getFlowBreadcrumbs = getFlowBreadcrumbs;
var getDeploymentBreadcrumbs = (0, _reselect.createSelector)(getCurrentProject, getCurrentDeploymentId, function (currentProject, deploymentId) {
  try {
    var _iterator4 = _createForOfIteratorHelper(currentProject.flows.assignmentList),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var assignment = _step4.value;
        var _iterator5 = _createForOfIteratorHelper(assignment.deploymentList),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var deployment = _step5.value;
            if (deployment.deploymentId === deploymentId) {
              return [currentProject.label, assignment.label, deployment.label];
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  } catch (error) {
    return [];
  }
  return [];
});
exports.getDeploymentBreadcrumbs = getDeploymentBreadcrumbs;
var getProjectLinks = (0, _reselect.createSelector)(getCurrentProject, function (currentProject) {
  return {
    base: "/quest/".concat(currentProject.groupId),
    design: "/quest/".concat(currentProject.groupId, "/design"),
    deploy: "/quest/".concat(currentProject.groupId, "/deploy")
  };
});
exports.getProjectLinks = getProjectLinks;
var getCurrentProjectExportData = (0, _reselect.createSelector)(getCurrentProjectAssignments, function (assignments) {
  var result = [];
  var _iterator6 = _createForOfIteratorHelper(assignments),
    _step6;
  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var assignment = _step6.value;
      result.push({
        id: result.length + 1,
        assignmentId: assignment.assignmentId,
        assignment: assignment.label,
        surveyId: 0,
        survey: '(all)'
      });
      var _iterator7 = _createForOfIteratorHelper(assignment.surveylistList),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var surveylistList = _step7.value;
          var _iterator8 = _createForOfIteratorHelper(surveylistList.surveyList),
            _step8;
          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var survey = _step8.value;
              result.push({
                id: result.length + 1,
                assignmentId: assignment.assignmentId,
                assignment: assignment.label,
                surveyId: survey.surveyId,
                survey: survey.label
              });
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }
  return result;
});
exports.getCurrentProjectExportData = getCurrentProjectExportData;
var getCurrentAssignment = (0, _reselect.createSelector)(getCurrentProjectAssignments, getCurrentAssignmentId, function (assignments, currentAssignmentId) {
  return assignments.find(function (item) {
    return item.assignmentId === currentAssignmentId;
  });
});
exports.getCurrentAssignment = getCurrentAssignment;
var getCurrentDeployment = (0, _reselect.createSelector)(getCurrentProjectDeployments, getCurrentDeploymentId, function (deployments, currentDeploymentId) {
  return deployments.find(function (item) {
    return item.deploymentId === currentDeploymentId;
  });
});
exports.getCurrentDeployment = getCurrentDeployment;
var getCurrentDeployments = (0, _reselect.createSelector)(getCurrentProjectDeployments, getCurrentDeploymentIds, function (deployments, currentDeploymentIds) {
  return deployments.filter(function (item) {
    return currentDeploymentIds.includes(item.deploymentId);
  });
});
exports.getCurrentDeployments = getCurrentDeployments;
var getCurrentSurvey = (0, _reselect.createSelector)(getCurrentAssignmentSurveys, getCurrentSurveyId, function (surveys, currentSurveyId) {
  return surveys.find(function (item) {
    return item.surveyId === currentSurveyId;
  });
});
exports.getCurrentSurvey = getCurrentSurvey;
var getCurrentDeploymentSurveys = (0, _reselect.createSelector)(getCurrentAssignmentSurveys, getCurrentDeployment, getCurrentProjectDeployments, function (surveys, deployment, allDeployments) {
  var allowedSurveyHandles = [];
  if (typeof deployment === 'undefined') {
    var _iterator9 = _createForOfIteratorHelper(allDeployments),
      _step9;
    try {
      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
        var index = _step9.value;
        var d = allDeployments[index];
        var options = (0, _get2["default"])(d, 'settings.options', []);
        var _iterator10 = _createForOfIteratorHelper(options),
          _step10;
        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var i = _step10.value;
            if (!allowedSurveyHandles.includes(options[i])) {
              allowedSurveyHandles.push(options[i]);
            }
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
      }
    } catch (err) {
      _iterator9.e(err);
    } finally {
      _iterator9.f();
    }
  } else {
    allowedSurveyHandles = (0, _get2["default"])(deployment, 'settings.options', []);
  }
  return surveys.filter(function (item) {
    return allowedSurveyHandles.includes(item.surveyHandle);
  });
});
exports.getCurrentDeploymentSurveys = getCurrentDeploymentSurveys;
var getCurrentProjectQueries = (0, _reselect.createSelector)(getQueryList, getCurrentProjectId, function (queryList, projectId) {
  var hasIdentifiablePermission = Fortress && Fortress.hasAccess('quest.view_identifiable_data', projectId);
  return queryList.filter(function (query) {
    if (query.projectId !== projectId) {
      return false;
    }
    if (query.settings.showQueryTo === 'withIdentifiable' && !hasIdentifiablePermission) {
      return false;
    }
    return true;
  }).sort(function (a, b) {
    return a.name.localeCompare(b.name);
  });
});
exports.getCurrentProjectQueries = getCurrentProjectQueries;
var getAvailableTags = (0, _reselect.createSelector)(getCurrentProjectQueries, function (projectQueries) {
  var list = new Set();
  projectQueries.forEach(function (project) {
    var _project$settings;
    (((_project$settings = project.settings) === null || _project$settings === void 0 ? void 0 : _project$settings.tags) || []).forEach(function (tag) {
      list.add(tag);
    });
  });
  return _toConsumableArray(list).sort(function (a, b) {
    return a.localeCompare(b);
  });
});
exports.getAvailableTags = getAvailableTags;
var getRestrictionsLevel = (0, _reselect.createSelector)(getOrganizationList, getCurrentProject, function (organizationList, currentProject) {
  var organization = organizationList.find(function (org) {
    return org.groupId === currentProject.organizationId;
  });
  if (!organization) {
    return 'unlimited';
  }
  var match = {
    Basic: 'basic',
    Premium: 'premium',
    Unlimited: 'unlimited'
  };
  return match[organization.restrictionsLevel] || 'unlimited';
});
exports.getRestrictionsLevel = getRestrictionsLevel;
var getCurrentProjectFields = (0, _reselect.createSelector)(getCurrentProject, function (currentProject) {
  return [1, 2, 3, 4, 5].map(function (num) {
    return {
      path: "fields.field_".concat(num),
      value: currentProject.fields["field_".concat(num)],
      isIdentifiable: Boolean(currentProject.fields["field_".concat(num, "_is_identifiable")])
    };
  }).filter(function (item) {
    return item.value;
  }).reduce(function (obj, item) {
    obj[item.path] = item;
    return obj;
  }, {});
});
exports.getCurrentProjectFields = getCurrentProjectFields;